import React, { useState } from 'react';
import { ONLINE_REGS_STATUSES } from 'shared/constants';
import './StudentGridCell.scss';
import { StudentStatus, StudentDetailsModal } from '../index';

const StudentGridCell = props => {
  const { cellData } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  return cellData ? (
    <div className={`cell student-cell ${ONLINE_REGS_STATUSES[cellData.testStatus]}`}>
      <div className={`name-section  ${ONLINE_REGS_STATUSES[cellData.testStatus]}`} tabIndex="0"
           onClick={toggleModal}>
        <div className="fw-bold">{cellData.lastName},</div>
        <div className="fw-bold">{cellData.firstName}</div>
      </div>
      <StudentStatus cellData={cellData} smallIcon />
      <StudentDetailsModal id={cellData.id} isOpen={isOpen} handleClose={toggleModal}/>
    </div>
  ) : (<div className="cell"></div>);
};

export default StudentGridCell;
